import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
   alert: {
      "& .MuiSvgIcon-root": {
         fontSize: 26,
      },
   },
});

export default useStyles;
